import './social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.WhatsappMessageContentView extends Monitoring.Views.SocialContents.SocialContentView

  initialize: (@options = {}) ->
    super(@options)
    @events['click .sc-wscontact-see-more'] = '_toggleContactExpander'
    @delegateEvents()

  _toggleContactExpander: (event) ->
    $seeMore = $(event.target)
    $container = $seeMore.closest('.whatsapp-contact-container').toggleClass 'sc-wscontact-collapsed'
    $seeMore.text(I18n.t("monitoring.dashboard.social_content.#{
      if $container.hasClass('sc-wscontact-collapsed') then 'see_more' else 'see_less'
    }"))
    false

  render: ->
    super
    @$el.addClass("content #{@model.type()} whatsapp_#{@model.get('data').whatsappMessage.messageType}")
    @_checkForTextParents()
    @whatsappAudioManager = new Monitoring.Views.WhatsappAudioControlsManager(@$el.find('.player-container'))
    @whatsappAudioManager._initWhatsappAudioControls()
    @_renderFullSizePopups()
    this

  _renderFullSizePopups: ->
    @$el.find('.sc-picture-preview').magnificPopup(type: 'image', closeOnContentClick: true)
    @$el.find('.sc-video-preview').magnificPopup(type: 'iframe', closeOnContentClick: true)

  _toggleShortener: (event) ->
    super
    $(event.target).prev().toggleClass 'sc-whatsapp-text-shortener'
    false

  _isWhatsappText: (whatsappMessage) ->
    return whatsappMessage.getWhatsappType() == "text"

  _checkForTextParents: ->
    if(@_isWhatsappText(@model._getContent())&& @_isParentMedia(@model._getContent()))
      @$el.find('.sc-text-shortener').addClass('sc-whatsapp-text-shortener')


  _isParentMedia: (whatsappContent) ->
    if(@_hasParent(whatsappContent) && !@_isWhatsappText(whatsappContent.getParent()))
      true
    else
      false

  _hasParent: ->
    @model._getContent().getParent()?
